import { InjectionToken } from '@angular/core';

export interface ChatOption {
  label: string
  nextNodeId?: string
  response?: string
}

export interface ChatNode {
  id: string
  message: string
  options?: ChatOption[]
}

export interface ChatbotConfig {
  botName: string
  botAvatar?: string
  primaryColor?: string
  welcomeMessage: string
  nodes: ChatNode[]
  rootNodeId: string
  position?: 'bottom-right' | 'bottom-left'
  contactInfo?: string
}

export interface ChatMessage {
  from: 'bot' | 'user'
  text: string
  options?: ChatOption[]
  optionsDisabled?: boolean
}

export const CHATBOT_CONFIG = new InjectionToken<ChatbotConfig>('CHATBOT_CONFIG')
